/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { ComponentFunction } from '../ComponentFunction/ComponentFunction.entity';
import { ComponentPreview } from '../ComponentPreview/ComponentPreview.entity';
import { ComponentStaticFiles } from '../ComponentStaticFiles/ComponentStaticFiles.entity';

/**
 * The dxp component manifest entity type.
 * @export
 */
export type EntityComponentManifest = io.TypeOf<typeof ComponentManifest>;

/**
 * The dxp component manifest entity definition.
 * @export
 */
export const ComponentManifest = io.intersection(
  [
    io.type({
      $schema: io.string,
      description: io.string,
      displayName: io.string,
      functions: io.array(ComponentFunction),
      mainFunction: io.string,
      name: io.string,
      namespace: io.string,
      type: io.union([io.undefined, io.string]),
      version: io.string,
    }),
    io.partial({
      environment: io.array(io.string),
      previews: io.record(io.string, ComponentPreview),
      staticFiles: ComponentStaticFiles,
    }),
  ],
  `ComponentManifest`,
);
